import { render, staticRenderFns } from "./Bottombar.vue?vue&type=template&id=4136a26f"
import script from "./Bottombar.vue?vue&type=script&lang=js"
export * from "./Bottombar.vue?vue&type=script&lang=js"
import style0 from "./Bottombar.vue?vue&type=style&index=0&id=4136a26f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports